// Role helpers — mirror the Rails User#role enum (snake_case) and the iOS tab
// map in Navigation/RoleBasedNavigation.swift. The backend is the source of
// truth (it returns canSell / canManageMall on the user, and re-checks every
// mutation), so these are for UI gating only. Prefer the server-provided
// `canManageMall` / `canSell` when present; fall back to deriving from role
// for sessions stored before those fields were added to the login payload.

export type Role =
  | 'guest' | 'shopper' | 'seller' | 'kol'
  | 'mall_admin' | 'mall_owner' | 'super_admin'

const MALL_ROLES: Role[] = ['mall_admin', 'mall_owner', 'super_admin']
const SELL_ROLES: Role[] = ['seller', 'kol', 'mall_admin', 'mall_owner', 'super_admin']

/** Can manage the mall: stores, products, assignments, mall settings. */
export function canManageMall(role?: string | null): boolean {
  return MALL_ROLES.includes(role as Role)
}

/** Can sell / has a seller surface (own store at minimum). */
export function canSell(role?: string | null): boolean {
  return SELL_ROLES.includes(role as Role)
}

/** Seller/KOL tier — own store only, no mall management. */
export function isSellerTier(role?: string | null): boolean {
  return role === 'seller' || role === 'kol'
}
